import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import MyFilter from "~/cabinet/vue/interface/filter/MyFilter.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import { FilterActionDescription} from "~/cabinet/ts/data/events/ActionDescription";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import Random from "~/ts/library/Random";
import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {computed, getCurrentInstance, nextTick} from "vue";
import StickyCard from "~/cabinet/vue/interface/card/StickyCard.vue";
import WindowHelper from "~/ts/library/WindowHelper";
import {IFilterCascadeBlockItemInterface} from "~/cabinet/vue/client/events/action/types/Interface";
import Draggable from "~/node_modules/vuedraggable/src/vuedraggable.js";



const __default__ = {
    name: "FilterBlockForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<FilterActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let instance = getCurrentInstance().proxy;

let _modelValue = _useModel<getActionDescriptionModelType<FilterActionDescription>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => ({
    filters: [
        getNewItem()
    ]
}))

let filters = computed(() => {
    return props.actionDescription.getFilters(props.contentVariables);
});

function getNewItem() {
    return {
        outputId: Random.uid(),
        filterValues: {},
        descr: null as string
    };
}

function sort(item: any, direction: number) {
    let list = model.value.filters;
    let index = list.indexOf(item);
    if (index > -1) {
        list.splice(index, 1);
        index += direction;
        list.splice(index, 0, item);
    }
}

function r(row: any): IFilterCascadeBlockItemInterface {
    return row;
}


function addVariant() {
    model.value.filters.push(getNewItem());
    nextTick(() => {
        try {
            let body: HTMLElement = (instance.$el as HTMLElement).closest(".el-dialog__body");
            let card: HTMLElement = body.querySelector(".filter-block:last-child");
            if (body && card) {
                WindowHelper.scrollToElement(card as HTMLElement, body, 500, -170);
            }
        } catch (e) {

        }
    });

}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StickyCard, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: addVariant
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Добавить еще один вариант ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Draggable), {
      modelValue: _unref(model).filters,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).filters) = $event)),
      handle: ".sortable-handler",
      name: "list",
      "item-key": "outputId",
      forceFallback: true,
      animation: 200
    }, {
      item: _withCtx(({element, index }) => [
        _createElementVNode("div", null, [
          (_openBlock(), _createBlock(_component_el_card, {
            key: r(element).outputId,
            class: "mt-4 filter-block"
          }, {
            default: _withCtx(() => [
              _createVNode(ElCardHeader, { "button-col-span": 12 }, {
                title: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, {
                    class: "sortable-handler cursor-move mr-2",
                    icon: "grip-vertical",
                    style: {"user-select":"none"},
                    onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                  }),
                  _createTextVNode(" Вариант " + _toDisplayString(index + 1), 1)
                ]),
                default: _withCtx(() => [
                  (index !== _unref(model).filters.length - 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => (sort(r(element), 1)),
                        link: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, {
                            icon: "chevron-down",
                            light: ""
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (index !== 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: ($event: any) => (sort(r(element), -1)),
                        link: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, {
                            icon: "chevron-up",
                            light: ""
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(model).filters.length > 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        link: "",
                        onClick: ($event: any) => (_unref(model).filters.splice(index, 1))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, { icon: "trash" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(ElCardSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(model).filters[index].descr,
                    "onUpdate:modelValue": ($event: any) => ((_unref(model).filters[index].descr) = $event),
                    placeholder: "Название для фильтров, будет видно в схеме. Необязательно для заполнения."
                  }, {
                    prepend: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Название", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(MyFilter, {
                    modelValue: _unref(model).filters[index].filterValues,
                    "onUpdate:modelValue": ($event: any) => ((_unref(model).filters[index].filterValues) = $event),
                    class: "mt-2",
                    "filters-data": _unref(filters)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "filters-data"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})